var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakepayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#E85350;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#F1F1F1;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#FCD479;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st4{fill:#69C1C7;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#060809;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 371.08,
    y: 40.8,
    className: "st0",
    width: 1352.23,
    height: 1352.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1452.83,1147.92c0,18.59-15.19,33.8-33.77,33.8H675.33c-18.59,0-33.82-15.21-33.82-33.8V674.63 c0-18.59,15.23-33.8,33.82-33.8h743.73c18.59,0,33.77,15.21,33.77,33.8V1147.92z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.24,
    y: 742.25,
    className: "st2",
    width: 33.8,
    height: 84.53
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.24,
    y: 995.79,
    className: "st2",
    width: 33.8,
    height: 84.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "709.13,691.54 709.13,742.25 726.04,742.25 726.04,826.78 709.13,826.78 709.13,995.79 726.04,995.79  726.04,1080.32 709.13,1080.32 709.13,1131 1385.24,1131 1385.24,691.54  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M810.57,1012.7c0,37.32,30.28,67.6,67.6,67.6c37.36,0,67.59-30.28,67.59-67.6c0-37.34-30.23-67.62-67.59-67.62 C840.85,945.08,810.57,975.36,810.57,1012.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M857.87,1012.7c0,11.21,9.11,20.26,20.29,20.26c11.2,0,20.29-9.06,20.29-20.26c0-11.23-9.08-20.29-20.29-20.29 C866.98,992.41,857.87,1001.47,857.87,1012.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M936.72,1046.5l-23.43-13.53L936.72,1046.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M843.04,992.41l-23.43-13.53L843.04,992.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M819.6,1046.5l23.43-13.53L819.6,1046.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M913.29,992.39l23.43-13.49L913.29,992.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M878.16,945.08v27.04V945.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M878.16,1053.25v27.04V1053.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1258.2,872.01c-17.42-35.92-51.9-61.91-92.94-67.55v-33.59c55.81,5.94,102.72,41.58,124.85,90.77 L1258.2,872.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1132,804.47c-41.09,5.64-75.56,31.63-92.98,67.55l-31.89-10.37c22.1-49.19,69.01-84.83,124.87-90.77V804.47z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1252.66,1040l-19.66-27.04c23.11-22.17,37.55-53.29,37.55-87.84c0-7.36-0.79-14.51-2.05-21.5l31.96-10.39 c2.14,10.3,3.31,20.94,3.31,31.89C1303.76,970.73,1283.96,1011.61,1252.66,1040z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1028.7,903.62c-1.24,6.99-2,14.14-2,21.5c0,34.54,14.44,65.66,37.52,87.86l-19.63,27.02 c-31.33-28.4-51.13-69.27-51.13-114.88c0-10.95,1.14-21.59,3.31-31.89L1028.7,903.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1091.1,1032.59c17.14,9.2,36.71,14.44,57.53,14.44c20.82,0,40.39-5.24,57.53-14.44l19.61,27 c-22.73,13.09-49.01,20.71-77.15,20.71c-28.14,0-54.41-7.59-77.19-20.68L1091.1,1032.59z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M974.68,868.59c2.86-8.73,12.23-13.51,20.96-10.67l119.26,38.76c4.61-5.47,10.39-9.88,17.1-12.6V758.86 c0-9.18,7.45-16.63,16.63-16.63c9.18,0,16.63,7.45,16.63,16.63v125.22c6.71,2.72,12.48,7.15,17.1,12.6l119.21-38.76 c8.76-2.84,18.12,1.96,20.96,10.67c2.84,8.73-1.96,18.12-10.67,20.96l-119.21,38.74c-0.56,7.38-2.8,14.25-6.48,20.19l73.61,101.35 c5.4,7.41,3.73,17.82-3.68,23.2c-7.41,5.4-17.84,3.77-23.2-3.68l-73.65-101.32c-3.4,0.84-6.94,1.42-10.62,1.42 c-3.68,0-7.22-0.58-10.62-1.42l-73.68,101.35c-5.38,7.43-15.79,9.06-23.2,3.68c-7.43-5.43-9.09-15.82-3.68-23.22l73.63-101.32 c-3.68-5.94-5.92-12.83-6.48-20.2l-119.23-38.78C976.64,886.71,971.87,877.3,974.68,868.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1104.28,925.14c0,24.46,19.85,44.3,44.35,44.3c24.46,0,44.3-19.85,44.3-44.3c0-24.5-19.84-44.35-44.3-44.35 C1124.13,880.8,1104.28,900.64,1104.28,925.14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "759.83,1240.87 726.04,1240.87 709.13,1181.71 776.72,1181.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1368.33,1240.87 1334.55,1240.87 1317.64,1181.71 1385.24,1181.71  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakepayment);
export default __webpack_public_path__ + "static/media/makepayment.0bcbb7bef5f1482d523e0fa6202ce44f.svg";
export { ForwardRef as ReactComponent };